import { IsNotEmpty, IsNumber } from 'class-validator';

export class UpdateBlockAttendanceDto {
  @IsNumber()
  @IsNotEmpty()
  blockId: number;
}
